import http from "@/utils/http";


export const WechatOauthApi = {

    render(params) {
        return http.get(`/server/weixin/oauth/render`,params)
    },
    check(params) {
        return http.get(`/server/weixin/oauth/check`,params)
    },
    login(data) {
        return http.post(`/server/weixin/oauth/login`,data)
    },
    binding(data) {
        return http.post(`/server/weixin/oauth/binding`,data)
    },
}